// Web3Forms access key registered to info@topnotchbakery.se
const INFO_WEB3FORMS_KEY = '1c356b66-d231-4b5b-87b7-77d4e9ef5c8d'
export const INFO_EMAIL = 'info@topnotchbakery.se'

interface InfoMail {
  subject: string
  message: string
  fromName: string
  replyTo: string
}

/** Sends a formatted email to info@topnotchbakery.se. Returns true on success. */
export async function sendInfoMail({
  subject,
  message,
  fromName,
  replyTo,
}: InfoMail): Promise<boolean> {
  try {
    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: INFO_WEB3FORMS_KEY,
        subject,
        from_name: fromName,
        replyto: replyTo,
        message,
      }),
    })
    const json = (await res.json().catch(() => null)) as {
      success?: boolean
    } | null
    return res.ok && !!json?.success
  } catch {
    return false
  }
}
